import React from "react";
import withExcute from "../withExcute";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  body: {
    fontSize: "12px",
    padding: `5px 13px`
  }
});

function CustomExcute(props) {
  const { children, style } = props;
  const classes = useStyles();

  return (
    <div style={style} className={classes.body}>
      {children}
    </div>
  );
}

export default withExcute(CustomExcute);
